import type { ReactNode } from 'react';

interface StatusBadgeProps {
  icon: ReactNode;
  label: string;
  value: string;
  tone?: 'neutral' | 'success' | 'muted' | 'live';
}

const TONE_CLASSES: Record<NonNullable<StatusBadgeProps['tone']>, string> = {
  neutral: 'text-text-primary',
  success: 'text-status-success',
  muted: 'text-text-muted',
  live: 'text-status-live',
};

export function StatusBadge({ icon, label, value, tone = 'neutral' }: StatusBadgeProps) {
  return (
    <div className="flex items-center gap-3">
      <span className="text-text-secondary">{icon}</span>
      <div>
        <div className="text-sm text-text-secondary">{label}</div>
        <div className={`text-sm font-medium ${TONE_CLASSES[tone]}`}>{value}</div>
      </div>
    </div>
  );
}
